import React, { useState, useEffect, useRef } from "react";
import { Modal, ModalHeader, ModalBody, Container, Row, Col } from "reactstrap";
import Button from "../button/Button";
import Form from "../Form/Form";
import Cookies from "js-cookie"; // install with: npm install js-cookie
import "./TimerModal.css";

const TimerModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(
    Cookies.get("hasSubmittedForm") === "true"
  );

  const timerRef = useRef(null);

  const toggleModal = () => setModalOpen(!modalOpen);
  const formToggleModal = () => setFormModalOpen(!formModalOpen);

  useEffect(() => {
    if (hasSubmitted) return;

    const startTimer = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setModalOpen(true), 120000);
    };

    const resetTimer = () => {
      clearTimeout(timerRef.current);
      startTimer();
    };

    startTimer();

    window.addEventListener("mousemove", resetTimer);

    return () => {
      clearTimeout(timerRef.current);
      window.removeEventListener("mousemove", resetTimer);
    };
  }, [hasSubmitted]);

  // When user clicks Submit in form, stop future modals
  const handleFormSubmit = () => {
    Cookies.set("hasSubmittedForm", "true", { expires: 7 }); // 7 days
    setHasSubmitted(true);
    setFormModalOpen(false);
    setModalOpen(false);
    clearTimeout(timerRef.current);
  };

  return (
    <>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        centered
        size="lg"
        contentClassName="custom-modal"
      >
        <ModalHeader toggle={toggleModal}></ModalHeader>
        <ModalBody className="d-flex justify-content-start align-items-center h-100">
          <Container fluid>
            <Row>
              <Col>
                <h1 className="popup-heading">
                  NEED HELP <br /> CHOOSING THE <br />
                  RIGHT OPTION?
                </h1>
                <p className="popup-trail">
                  We're here if you'd like some guidance
                </p>
                <Button
                  label="GET ASSISTANCE"
                  orange={true}
                 
                  height="65.86661px"
                  margin="20px 0"
                  fontSize={22}
                  fontWeight="500"
                  textColor="#fff"
                  onClick={() => {
                    formToggleModal();
                    setModalOpen(false);
                  }}
                  fontFamily="Proxima Nova Bold"
                />
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>

      <Form
        modal={formModalOpen}
        toggle={formToggleModal}
        additionalField={true}
        heading="Get the Guidance you Need"
        description="Share a few details and we’ll help you move forward with your study plans for this destination."
        aus={true}
        closingMessage="YOU'RE ONE STEP CLOSER TO STARTING SMART"
        closingDesc="Our counselor will connect with you shortly"
        onClickSubmit={handleFormSubmit} // Pass function to handle submit
      />
    </>
  );
};

export default TimerModal;
